import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import type { ScoreGroup } from '../lib/ai-first-score';

// One state's items on the scorecard — a heading with the count, then one line
// per item: its label and its FIRST evidence entry. Presenter.
//
// Evidence is a POINTER the box wrote (a path, a command and its exit, a count),
// bounded at the domain and rendered as text. An item with none says so: a `gap`
// is often "nothing exists", and a blank would read as a rendering fault.

export function RepoScorecardGroup(props: { readonly group: ScoreGroup }): JSX.Element {
  return (
    <div class="repo-scorecard__group" data-state={props.group.state}>
      <h3 class="repo-scorecard__group-title">
        {t(`repo_detail.score_group_${props.group.state}`)}{' '}
        <span class="badge badge--secondary">{props.group.items.length}</span>
      </h3>
      <ul class="repo-scorecard__items">
        <For each={props.group.items}>
          {(line) => (
            <li class="repo-scorecard__item">
              <span class="repo-scorecard__item-name">
                {t(`repo_detail.score_item_${line.id}`)}
              </span>
              <span
                classList={{
                  'repo-scorecard__evidence': true,
                  'repo-scorecard__evidence--none': line.evidence === null,
                }}
              >
                {line.evidence ?? t('repo_detail.score_no_evidence')}
              </span>
            </li>
          )}
        </For>
      </ul>
    </div>
  );
}
